import ApiClient from "../helpers/ApiClient";

const baseSuporteEndpoint = () => `/suporte/`;

const listTickets = () => ApiClient.apiClientDev.get(baseSuporteEndpoint());

const getTicket = (id) =>
  ApiClient.apiClientDev.get(`${baseSuporteEndpoint()}${id}/`);

const putTicket = (id, data) =>
  ApiClient.apiClientDev.put(`${baseSuporteEndpoint()}${id}/`, data);

const postTicket = (data) =>
  ApiClient.apiClientDev.post(baseSuporteEndpoint(), data);

const SuporteApiClient = { listTickets, putTicket, getTicket, postTicket };
export default SuporteApiClient;
